import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
function metaFieldIdToName(metaFieldId, metaFields, file) {
    const fields = typeof metaFields === 'function' ? metaFields(file) : metaFields;
    const field = fields?.find((f) => f.id === metaFieldId);
    // `requiredMetaFields` is a core restriction, so a field can be required
    // without having a matching entry in the Dashboard `metaFields` option.
    return field?.name ?? metaFieldId;
}
export default function MetaErrorMessage(props) {
    const { file, toggleFileCard, i18n, metaFields } = props;
    const { missingRequiredMetaFields } = file;
    if (!missingRequiredMetaFields?.length) {
        return null;
    }
    const metaFieldsString = missingRequiredMetaFields
        .map((missingMetaField) => metaFieldIdToName(missingMetaField, metaFields, file))
        .join(', ');
    return (_jsxs("div", { className: "uppy-Dashboard-Item-errorMessage", children: [i18n('missingRequiredMetaFields', {
                smart_count: missingRequiredMetaFields.length,
                fields: metaFieldsString,
            }), ' ', _jsx("button", { type: "button", class: "uppy-u-reset uppy-Dashboard-Item-errorMessageBtn", onClick: () => toggleFileCard(true, file.id), children: i18n('editFile') })] }));
}
